module.exports = __webpack_public_path__ + "img/empty.d231e665.svg";